import React from 'react';
import CONFIG from '../../../config';

import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Document from './Document';
import GroupDocument from './GroupDocument';
import GroupState from './GroupState';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DocumentState from './DocumentState';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import WidgetAlertbox from '../../../components/widgets/WidgetAlertbox';


function MetaGroupDocument({ user, setUser, metaGroupIcon, metaGroupName, groupList, grantLocataire = null, commentary }) {
  const navigate = useNavigate();
  var messageAlertSuppr = "";

  if (grantLocataire !== null && grantLocataire !== 'deuxieme_locataire' && grantLocataire !== 'visale') {
    messageAlertSuppr = "Voulez vous vraiment supprimer ce garant ?";
  } else if (grantLocataire !== null && grantLocataire === 'deuxieme_locataire') {
    messageAlertSuppr = "Voulez vous vraiment supprimer le deuxième locataire ?";
  } else if (grantLocataire !== null && grantLocataire === 'visale') {
    messageAlertSuppr = "Voulez vous vraiment supprimer la garantie visale ?";
  }

  const [alertDelete, openAlertDelete] = WidgetAlertbox(messageAlertSuppr);

  const [collapse, setCollapse] = React.useState(false);
  const [collapseQuestionnaire, setCollapseQuestionnaire] = React.useState(false);

  const states = groupList.map((x) => {
    return x.documentsList.map((documentData) => {
      var document = null;
      if (documentData.type_dossier == 'deuxieme_locataire') {
        document = user.dossier.deuxieme_locataire.documents[documentData.document_name];
      } else if (documentData.type_dossier == 'dossier') {
        document = user.dossier.documents[documentData.document_name];
      } else {
        document = user.dossier.list_garants[documentData.type_dossier].documents[documentData.document_name];
      }

      return document.etat;
    })
  }).flat(1);

  const facultatifList = groupList.map((x) => {
    return x.documentsList.map((documentData) => {
      return documentData.facultatif;
    })
  }).flat(1);


  return (
    <>
      {alertDelete}
      <div className='col-span-12 w-full grid grid-cols-12 gap-x-4 shrink-0'>
        <div className={'col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer ' + ((!collapse) ? 'rounded-xl' : 'rounded-t-xl')} onClick={() => setCollapse(!collapse)}>
          <div className='flex col-span-8 w-full items-end'>
            <div className='pr-2 text-ame-gray'>
              {metaGroupIcon}
            </div>
            <div>
              <h3>{metaGroupName}</h3>
            </div>
          </div>

          <GroupState etatList={states} facultatifList={facultatifList} />

          <div className='col-span-12 w-full items-end text-red-500 font-bold'>
            {commentary}
          </div>
        </div>
        <div className='col-span-12 w-full px-6 rounded-b-xl shadow-inner shadow-gray-100 bg-gray-50'>
          <Collapse in={collapse}>

            {grantLocataire !== null && grantLocataire === 'deuxieme_locataire' &&
              <div className='divide-y m-6 grid grid-cols-12 gap-x-4 shrink-0 max-w-4xl mx-auto bg-white my-shadow'>
                <div className='col-span-12 w-full grid grid-cols-12 gap-x-4 shrink-0'>
                  <div className='col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer rounded-xl' onClick={() => setCollapseQuestionnaire(!collapseQuestionnaire)}>
                    <div className='flex col-span-8 w-full items-end'>
                      <div className='pr-2 text-ame-gray'>
                        <FormatListBulletedIcon fontSize='large'></FormatListBulletedIcon>
                      </div>
                      <div>
                        <h3>Information locataire n°2</h3>
                      </div>
                    </div>

                    <DocumentState etat={user.dossier.deuxieme_locataire.questionnaire_etat} />
                  </div>

                  <div className='col-span-12 w-full px-6 shadow-inner shadow-gray-100'>
                    <Collapse in={collapseQuestionnaire}>
                      <hr className='mb-6'></hr>
                      <div className='col-span-12 w-full grid grid-cols-12 gap-4 pb-6'>
                        <div className='col-span-10 w-full'>
                          Nous avons besoin de ces informations pour ajuster les documents demandés.
                          <br></br>
                          <br></br>
                          <span className='text-red-500 font-bold'>
                            {user.dossier.deuxieme_locataire.questionnaire_message}
                          </span>
                        </div>

                        <div className='col-span-2 w-full text-center flex flex-col justify-end'>
                          <Button variant={(user.dossier.deuxieme_locataire.questionnaire_etat === 'manquant') ? "contained" : "outlined"} onClick={() => navigate("/client/questionnaire_locataire/0")}>{(user.dossier.deuxieme_locataire.questionnaire_etat === 'manquant') ? "Répondre" : "Consulter"}</Button>
                        </div>
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
            }

            {grantLocataire !== null && grantLocataire !== 'deuxieme_locataire' && grantLocataire !== 'visale' &&
              <div className='divide-y m-6 grid grid-cols-12 gap-x-4 shrink-0 max-w-4xl mx-auto bg-white my-shadow'>
                <div className='col-span-12 w-full grid grid-cols-12 gap-x-4 shrink-0'>
                  <div className='col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer rounded-xl' onClick={() => setCollapseQuestionnaire(!collapseQuestionnaire)}>
                    <div className='flex col-span-8 w-full items-end'>
                      <div className='pr-2 text-ame-gray'>
                        <FormatListBulletedIcon fontSize='large'></FormatListBulletedIcon>
                      </div>
                      <div>
                        <h3>Information garant n°{grantLocataire + 1}</h3>
                      </div>
                    </div>

                    <DocumentState etat={user.dossier.list_garants[grantLocataire].questionnaire_etat} />
                  </div>

                  <div className='col-span-12 w-full px-6 shadow-inner shadow-gray-100'>
                    <Collapse in={collapseQuestionnaire}>
                      <hr className='mb-6'></hr>
                      <div className='col-span-12 w-full grid grid-cols-12 gap-4 pb-6'>
                        <div className='col-span-10 w-full'>
                          Nous avons besoin de ces informations pour ajuster les documents demandés.
                          <br></br>
                          <br></br>
                          <span className='text-red-500 font-bold'>
                            {user.dossier.deuxieme_locataire.questionnaire_message}
                          </span>
                        </div>

                        <div className='col-span-2 w-full text-center flex flex-col justify-end'>
                          <Button variant={(user.dossier.list_garants[grantLocataire].questionnaire_etat === 'manquant') ? "contained" : "outlined"} onClick={() => navigate("/client/questionnaire_garant/" + grantLocataire)}>{(user.dossier.list_garants[grantLocataire].questionnaire_etat === 'manquant') ? "Répondre" : "Consulter"}</Button>
                        </div>
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
            }


            <div className='divide-y m-6 grid grid-cols-12 gap-x-4 shrink-0 max-w-4xl mx-auto bg-white my-shadow'>
              {groupList.map((group) => (
                <GroupDocument key={group.groupName} user={user} setUser={setUser} groupIcon={group.groupIcon} groupName={group.groupName} documents={group.documentsList}></GroupDocument>
              ))}
            </div>

            {grantLocataire === null &&
              < div className='gap-x-4 p-6 pt-0 pr-0 flex flex-row-reverse'>
                <Button variant='contained' className='ml-4' onClick={() => setCollapse(!collapse)}>Valider</Button>
              </div>
            }

            {grantLocataire !== null && grantLocataire !== 'deuxieme_locataire' && grantLocataire !== 'visale' &&
              < div className='gap-x-4 p-6 pt-0 pr-0 flex flex-row-reverse'>
                <Button variant='contained' className='ml-4' onClick={() => setCollapse(!collapse)}>Valider</Button>
                {/* <Button variant='contained' className='ml-4' onClick={() => navigate('/client/questionnaire_garant/' + grantLocataire)}>Modifier les informations</Button> */}
                <Button variant='outlined' className='ml-4'
                  onClick={() => openAlertDelete(() => {
                    axios.post(CONFIG.API_URL + '/api/client_delete_garant/' + grantLocataire, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            setUser(response.data);
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                            break;
                        }
                      });
                  })}
                >Supprimer le garant</Button>
              </div>
            }

            {grantLocataire !== null && grantLocataire === 'deuxieme_locataire' &&
              < div className='gap-x-4 p-6 pt-0 pr-0 flex flex-row-reverse'>
                <Button variant='contained' className='ml-4' onClick={() => setCollapse(!collapse)}>Valider</Button>
                {/* <Button variant='contained' className='ml-4' onClick={() => navigate('/client/questionnaire_locataire/0')}>Modifier les informations</Button> */}
                <Button variant='outlined' className='ml-4'
                  onClick={() => openAlertDelete(() => {
                    axios.post(CONFIG.API_URL + '/api/client_delete_locataire', {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            setUser(response.data);
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                            break;
                        }
                      });
                  })}
                >Supprimer le locataire</Button>
              </div>
            }


            {grantLocataire !== null && grantLocataire === 'visale' &&
              < div className='gap-x-4 p-6 pt-0 pr-0 flex flex-row-reverse'>
                <Button variant='contained' className='ml-4' onClick={() => setCollapse(!collapse)}>Valider</Button>
                <Button variant='outlined' className='ml-4'
                  onClick={() => openAlertDelete(() => {
                    axios.post(CONFIG.API_URL + '/api/client_delete_visale', {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            setUser(response.data);
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                            break;
                        }
                      });
                  })}
                >Supprimer la garantie</Button>
              </div>
            }
          </Collapse>
        </div >
      </div >
    </>
  );
}

export default MetaGroupDocument;